import * as React from 'react'
import { StyleSheet, Text } from 'react-native'
import { Skeleton } from '@components/Skeleton'
import { black } from '@themes/Colors'
import Fonts from '@themes/Fonts'

type Props = {
  isLoading?: boolean
  text?: string
  size?: 'default' | 'small' | 'medium' | 'big'
  numberOfLines?: number
}

export const Title = ({
  isLoading = false,
  text,
  size = 'default',
  numberOfLines = 1,
}: Props) => {
  const fontSizes = {
    default: 20,
    small: 18,
    medium: 22,
    big: 26,
  }

  const fontSize = fontSizes[size]

  return isLoading ? (
    <Skeleton height={fontSize + 4} width={'61%'} />
  ) : (
    <Text
      accessibilityRole="header"
      numberOfLines={numberOfLines}
      style={[styles.text, { fontSize }]}
    >
      {text}
    </Text>
  )
}

const styles = StyleSheet.create({
  text: {
    fontFamily: Fonts.type.bold,
    fontWeight: 'bold',
    color: black,
    paddingBottom: 4,
  },
})
